import { useParams, Link, Navigate } from "react-router-dom";
import PageHeader from "@/components/layout/PageHeader";
import ContactBlock from "@/components/sections/ContactBlock";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Testimonials from "@/components/sections/Testimonials";
import { SERVICES, SERVICE_AREAS } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export default function ServiceAreaPage() {
  const { slug } = useParams();
  const area = SERVICE_AREAS.find((a) => a.slug === slug);
  if (!area) return <Navigate to="/contact" replace />;

  return (
    <div data-testid={`service-area-${area.slug}`}>
      <PageHeader
        overline={`Serving ${area.name}`}
        title={`${area.name} construction, plumbing & HVAC experts.`}
        sub={`ME Builders provides full-service construction, plumbing, HVAC, drywall and remodeling throughout ${area.name} — with the same clean craftsmanship and reliable scheduling we bring to every project.`}
        image="https://images.pexels.com/photos/36241380/pexels-photo-36241380.jpeg"
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Areas" }, { label: area.name }]}
      />

      <section className="section-pad">
        <div className="container-page grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="overline mb-3">Local expertise</p>
            <h2 className="heading-2">A local team that knows {area.name} homes.</h2>
            <p className="body-base mt-5">
              From mid-century homes to modern new builds, we understand the systems and styles common to {area.name}. We arrive prepared, communicate clearly and finish clean.
            </p>
          </div>
          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {SERVICES.map((s) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`area-service-${s.slug}`}
                className="card-base p-5 hover:border-brand-obsidian transition-colors group"
              >
                <p className="font-heading text-lg font-bold text-brand-ink">{s.title} in {area.name}</p>
                <p className="body-sm mt-1.5">{s.short}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.2em] text-brand-ink group-hover:text-brand-olive-hover">
                  See service <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <Testimonials />
      <ContactBlock source={`area_${area.slug}`} />
    </div>
  );
}
